import { useTranslation } from 'react-i18next';
import { useChatContext } from 'components/Chat/ChatContext';

/**
 * Custom hook for chat translations that uses chat-specific language settings
 * Falls back to regular useTranslation if no chat context is available
 */
export function useChatTranslation() {
  const chatContext = useChatContext();
  const { t, i18n } = useTranslation();

  // Return translation function that uses chat language
  const chatT = (key: string, options?: any) => {
    if (chatContext?.chatLanguage) {
      return i18n.getFixedT(chatContext.chatLanguage)(key, options);
    }
    return t(key, options);
  };

  return {
    t: chatT,
    chatLanguage: chatContext?.chatLanguage || i18n.language,
  };
}
